import { render, staticRenderFns } from "./BronchialAsthma.vue?vue&type=template&id=13255548&scoped=true"
import script from "./BronchialAsthma.vue?vue&type=script&lang=js"
export * from "./BronchialAsthma.vue?vue&type=script&lang=js"
import style0 from "./BronchialAsthma.vue?vue&type=style&index=0&id=13255548&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13255548",
  null
  
)

export default component.exports